// Single source of truth for Dash list prices. Rendered on /pricing and used
// to build the schema.org Offer data, so the visible page and the structured
// data can never drift apart.

export type Tier = {
  name: string;
  n: string;
  price: string;
  cadence: string;
  summary: string;
  included: string[];
  /** Flat monthly price in USD, used for structured data. */
  monthlyUsd: number;
  /** True when monthlyUsd is a starting price rather than a fixed price. */
  startingAt?: boolean;
  highlight?: boolean;
};

export const TIERS: Tier[] = [
  {
    n: "01",
    name: "Starter",
    price: "$49",
    cadence: "per month",
    monthlyUsd: 49,
    summary:
      "For solo operators. One line, one calendar, one inbox. Dash picks up when you can't.",
    included: [
      "1 forwarded phone line",
      "Up to 200 answered calls / mo",
      "Cal.com booking",
      "Email summaries",
      "7-day call archive",
    ],
  },
  {
    n: "02",
    name: "Business",
    price: "$149",
    cadence: "per month",
    monthlyUsd: 149,
    summary:
      "For small teams. Round-robin scheduling, custom greeting, longer memory.",
    included: [
      "Up to 1,000 answered calls / mo",
      "Multi-host round-robin booking",
      "Custom greeting + voice",
      "90-day call archive",
      "Priority email support",
    ],
    highlight: true,
  },
  {
    n: "03",
    name: "Bespoke",
    price: "From $399",
    cadence: "let's talk",
    monthlyUsd: 399,
    startingAt: true,
    summary:
      "For multi-location operators. Custom integrations, SLAs, and concierge onboarding.",
    included: [
      "Unlimited answered calls",
      "Custom CRM / dispatch integration",
      "Signed SLA",
      "Dedicated onboarding",
      "Indefinite call archive",
    ],
  },
];
